<template>
    <div class="left-text">
        <div @mouseover="stop" @mouseleave="start">
            <h3 class="menber" style="color: red" :title="tips"> {{title}} </h3>
            <a :href="link" class="now-in" :title="tips" target="_blank">{{button }}</a>
        </div>
    </div>
</template>

<script>
export default {
  name: 'LeftText',
  components: {},
  data() {
    return {
      itemList: [],
      tempList: [],
      random: 0,
      link: 'https://gityx.com/notify/30.html',
      tips: '欢迎关注公众号：Gityx游戏',
      button: '前往关注',
      title: '欢迎关注公众号：Gityx游戏',
      timer: null
    }
  },
  created() {
    this.getData()
  },
  mounted() {
    this.$nextTick(function() {
      this.timer = setInterval(this.randomData, 3000)
    })
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    start() {
      this.timer = setInterval(this.randomData, 3000)
    },
    stop() {
      clearInterval(this.timer)
    },
    getData() {
      this.itemList = []
      var timeStamp = new Date().getTime()
      this.$http.get('static/data/home_text_link.json' + '?' + timeStamp).then(res => {
        for (var j = 0; j < res.data.length; j++) {
          if (res.data[j].status !== 0) {
            this.tempList.push(res.data[j])
          }
        }
      },
      res => {
        console.log('error')
      }
      )
    },
    randomData() {
      var i = Math.floor(Math.random() * this.tempList.length)
      //                        console.log(this.tempList.length)
      this.title = this.tempList[i].title
      this.tips = this.tempList[i].tips
      this.button = this.tempList[i].button
      this.link = this.tempList[i].link
    }
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
